<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { PaginationList, type PaginationListProps } from "reka-ui";
import { cn } from "@/shared/lib/utils";

type PageItem = { type: "page"; value: number } | { type: "ellipsis" };

const props = defineProps<
  PaginationListProps & {
    class?: HTMLAttributes["class"];
  }
>();

defineSlots<{
  default?: (props: { items: PageItem[] }) => unknown;
}>();
</script>

<template>
  <PaginationList
    v-bind="props"
    :class="
      cn(
        'flex flex-wrap items-center gap-1',
        props.class,
      )
    "
  >
    <slot />
  </PaginationList>
</template>
